import React, { useState } from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Send, Loader2, CheckCircle2, Clock } from "lucide-react";
import PageHero from "../components/PageHero";
import { sendContact } from "../lib/api";
import { CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE } from "../constants/contact";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await sendContact(form);
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
      setTimeout(() => setStatus("idle"), 4000);
    } catch { setStatus("error"); }
  };

  const infos = [
    { icon: Phone, title: "Telefon", value: CONTACT_PHONE },
    { icon: Mail, title: "E-posta", value: CONTACT_EMAIL },
    { icon: MapPin, title: "Adres", value: CONTACT_ADDRESS },
    { icon: Clock, title: "Çalışma Saatleri", value: "Hafta içi 09:00 - 18:00" },
  ];

  return (
    <div>
      <PageHero
        title="Bize" highlight="Ulaşın"
        subtitle="Sorularınız, iş birlikleri ve reklam talepleriniz için bizimle iletişime geçin."
        image="https://images.unsplash.com/photo-1565382038303-8c62e88d119a"
      />
      <div className="tv-container py-14 grid lg:grid-cols-2 gap-8">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="space-y-4">
          {infos.map((info, i) => (
            <div key={i} className="tv-card p-5 flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[rgba(139,92,246,0.15)] border border-[rgba(168,85,247,0.3)] flex items-center justify-center shrink-0">
                <info.icon size={22} className="text-[var(--tv-purple-bright)]" />
              </div>
              <div>
                <h3 className="text-white font-semibold">{info.title}</h3>
                <p className="text-[var(--tv-muted)] text-sm mt-1">{info.value}</p>
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="tv-card p-7 md:p-8">
          <h2 className="text-2xl font-bold text-white font-display mb-6">Mesaj Gönderin</h2>
          <form onSubmit={submit} className="space-y-4">
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Adınız Soyadınız" className="tv-input" />
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="E-posta Adresiniz" className="tv-input" />
            <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Mesajınız" className="tv-input resize-none" />
            <button disabled={status === "loading"} className="tv-btn-primary w-full">
              {status === "loading" ? <Loader2 size={18} className="animate-spin" /> : status === "success" ? <CheckCircle2 size={18} /> : <Send size={18} />}
              {status === "success" ? "Mesajınız Alındı!" : "Mesaj Gönder"}
            </button>
            {status === "error" && <p className="text-red-400 text-sm text-center">Bir hata oluştu, lütfen tekrar deneyin.</p>}
          </form>
        </motion.div>
      </div>
    </div>
  );
}
